module.exports = __webpack_public_path__ + "static/media/filter.00749a61.svg";